function getStep1Module2State(state) {
  return {
    hasCoordinates: state.step1Module2.coordinates,
    isEdited: state.step1Module2.isEdited,
    hasLocation: state.step1Module2.hasLocation,
    formValues: {
      address: state.step1Module2.address,
      selectedProvince: state.step1Module2.selectedProvince,
      selectedCity: state.step1Module2.selectedCity,
      selectedDistrict: state.step1Module2.selectedDistrict,
      selectedSubDistrict: state.step1Module2.selectedSubDistrict,
      provinceData: state.step1Module2.provinceData,
      cityData: state.step1Module2.cityData,
      districtData: state.step1Module2.districtData,
      subDistrictData: state.step1Module2.subDistrictData,
      locationInfo: state.step1Module2.locationInfo[0]
    },
    hasValues: state.step1Module2.hasValues,
    isCompleted: state.step1Module2.isCompleted,
    visibility: state.step1Module2.visibility,
    cep: state.step1Module2.cep,
    cepError: state.step1Module2.cepError,
    loadingDistrict: state.step1Module2.loadingDistrict,
    addressComplement: state.step1Module2.addressComplement
  };
}

export { getStep1Module2State };
